<template>
401
</template>

<script>
export default {
  name: "AppError_401"
}
</script>

<style scoped>

</style>